export var EmailType;
(function (EmailType) {
    EmailType[EmailType["SfeermasterActionList"] = 0] = "SfeermasterActionList";
    EmailType[EmailType["JubileesMonthlyOverview"] = 1] = "JubileesMonthlyOverview";
    EmailType[EmailType["EventReminder"] = 2] = "EventReminder"; // Days before event - Event reminder
})(EmailType || (EmailType = {}));
